/**
 * 阴阳分支 (☯️ 神秘科技) - 共18项
 * 严格按照 docs/TECH_TREE_DESIGN.md 设计
 */

import type { Tech } from '../TechTypes';

export const YINYANG_TECHS: Tech[] = [
  // 第一层：基础玄学 (3项)
  {
    id: 'Y001',
    name: '阴阳五行',
    description: '五行之基：解锁元素系统',
    branch: 'yinyang',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { forestBonus: 1.1, hillBonus: 1.1 },
    },
    position: { x: 20, y: 10 },
    icon: '☯️',
  },
  {
    id: 'Y002',
    name: '奇门遁甲',
    description: '遁术之法',
    branch: 'yinyang',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { speedBonus: 1.2 },
      special: { ambush: true },
    },
    position: { x: 50, y: 10 },
    icon: '🚪',
  },
  {
    id: 'Y003',
    name: '周易占卜',
    description: '卜筮之术：预知吉凶，研究速度+10%，士气+15%',
    branch: 'yinyang',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { researchSpeedBonus: 1.1, morale: 1.15 },
    },
    position: { x: 80, y: 10 },
    icon: '🔮',
  },

  // 第二层：进阶玄学 (5项)
  {
    id: 'Y011',
    name: '金行：白虎',
    description: '白虎之力：金属性单位攻击+25%',
    branch: 'yinyang',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['Y001'],
    effects: {
      bonuses: { swordAttack: 1.25 },
    },
    position: { x: 10, y: 25 },
    icon: '🐯',
  },
  {
    id: 'Y012',
    name: '木行：青龙',
    description: '青龙之护：木属性单位生命+25%',
    branch: 'yinyang',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['Y001'],
    effects: {
      bonuses: { unitHealthBonus: 1.25 },
    },
    position: { x: 30, y: 25 },
    icon: '🐲',
  },
  {
    id: 'Y013',
    name: '水行：玄武',
    description: '玄武之盾：水属性单位防御+25%',
    branch: 'yinyang',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['Y001'],
    effects: {
      bonuses: { shieldDefense: 1.25 },
    },
    position: { x: 50, y: 25 },
    icon: '🐢',
  },
  {
    id: 'Y014',
    name: '隐身之术',
    description: '遁形隐匿：特殊单位可隐身',
    branch: 'yinyang',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['Y002'],
    effects: {
      bonuses: { forestBonus: 1.4 },
      special: { ambush: true },
    },
    position: { x: 70, y: 25 },
    icon: '👻',
  },
  {
    id: 'Y015',
    name: '天眼通明',
    description: '千里眼：弓兵射程+20%，弓兵攻击+15%',
    branch: 'yinyang',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['Y003'],
    effects: {
      bonuses: { archerRange: 1.2, archerAttack: 1.15 },
    },
    position: { x: 90, y: 25 },
    icon: '👁️',
  },

  // 第三层：高级玄学 (5项)
  {
    id: 'Y021',
    name: '火行：朱雀',
    description: '朱雀之焰：火属性单位获得灼烧效果',
    branch: 'yinyang',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['Y011'],
    effects: {
      bonuses: { attackBonus: 1.2 },
      special: { fireArrows: true },
    },
    position: { x: 10, y: 45 },
    icon: '🦅',
  },
  {
    id: 'Y022',
    name: '土行：麒麟',
    description: '麒麟之韧：土属性单位获得反伤效果',
    branch: 'yinyang',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['Y012', 'Y013'],
    effects: {
      bonuses: { defenseBonus: 1.3, shieldBlock: 1.2 },
    },
    position: { x: 30, y: 45 },
    icon: '🦌',
  },
  {
    id: 'Y023',
    name: '五行相生',
    description: '五行调和：相邻不同属性单位互相增益',
    branch: 'yinyang',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['Y011', 'Y012', 'Y013'],
    effects: {
      bonuses: { morale: 1.3, attackBonus: 1.15, defenseBonus: 1.15 },
    },
    position: { x: 50, y: 45 },
    icon: '🔄',
  },
  {
    id: 'Y024',
    name: '神行百变',
    description: '踏雪无痕：隐身单位移速+50%，可穿越地形',
    branch: 'yinyang',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['Y014'],
    effects: {
      bonuses: { speedBonus: 1.5, forestBonus: 1.3 },
    },
    position: { x: 70, y: 45 },
    icon: '🌬️',
  },
  {
    id: 'Y025',
    name: '洞察秋毫',
    description: '破隐之眼：防御+20%，士气+15%，敌方伏击无效',
    branch: 'yinyang',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['Y015'],
    effects: {
      bonuses: { defenseBonus: 1.2, morale: 1.15 },
    },
    position: { x: 90, y: 45 },
    icon: '🔍',
  },

  // 第四层：大师玄学 (3项)
  {
    id: 'Y031',
    name: '五行大阵',
    description: '五行合一：解锁五行阵法，全军获得属性加成',
    branch: 'yinyang',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['Y021', 'Y022', 'Y023'],
    effects: {
      bonuses: { attackBonus: 1.25, defenseBonus: 1.25, morale: 1.3 },
      special: { phalanx: true },
    },
    position: { x: 20, y: 65 },
    icon: '🌟',
  },
  {
    id: 'Y032',
    name: '奇门八卦',
    description: '八门遁甲：解锁战场传送门，可瞬移部队',
    branch: 'yinyang',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['Y023', 'Y024'],
    effects: {
      bonuses: { speedBonus: 1.5 },
    },
    position: { x: 50, y: 65 },
    icon: '🎯',
  },
  {
    id: 'Y033',
    name: '天机莫测',
    description: '迷雾大师：士气+30%，防御+25%，敌军混乱',
    branch: 'yinyang',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['Y024', 'Y025'],
    effects: {
      bonuses: { morale: 1.3, defenseBonus: 1.25 },
    },
    position: { x: 80, y: 65 },
    icon: '🌙',
  },

  // 第五层：终极玄学 (2项) [互斥]
  {
    id: 'Y041',
    name: '呼风唤雨',
    description: '元素终极：解锁天气控制，战场环境随意改变',
    branch: 'yinyang',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['Y031'],
    mutuallyExclusive: ['Y042'],
    effects: {
      bonuses: { forestBonus: 1.5, hillBonus: 1.5, morale: 1.4 },
    },
    position: { x: 35, y: 85 },
    nodeShape: 'hexagon',
    icon: '🌪️',
    quote: '呼风唤雨，翻云覆手',
  },
  {
    id: 'Y042',
    name: '六丁六甲',
    description: '神兵终极：召唤神兵天将，无视地形与城墙',
    branch: 'yinyang',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['Y032', 'Y033'],
    mutuallyExclusive: ['Y041'],
    effects: {
      bonuses: { attackBonus: 1.4, speedBonus: 1.4 },
    },
    position: { x: 65, y: 85 },
    nodeShape: 'hexagon',
    icon: '👼',
    quote: '六丁六甲，神兵天降',
  },
];
